import { IPassengerInfo, NO_VALUE_DISPLAY } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvRidePassengerListCellTransformer = (): {
  getRidePassengerListValue: CsvCellTransformerFn;
} => {
  const getPassengersList = (passengersInfo: IPassengerInfo[]): string => {
    return passengersInfo
      .map(({ firstName, lastName, code, unitName, phone }, index) => {
        const fullName = `${firstName} ${lastName}`;
        return `<${fullName}${code ? ` | #${code}` : ""}${unitName ? ` | (${unitName})` : ""}${phone ? ` | ${phone}` : ""}>`;
      })
      .join(", ");
  };

  const getRidePassengerListValue = ({
    value,
  }: ICsvColumnTransformer): string => {
    if (!value?.length) {
      return NO_VALUE_DISPLAY;
    }

    return getPassengersList(value as IPassengerInfo[]);
  };

  return { getRidePassengerListValue };
};
